
import '../Contacts/contact.css';



function Contact() {

 
    return (
      <div>
      <div className="container">
          <div className="column2">
            <h2>Werk 1</h2>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5984.374903011592!2d-8.464186874793862!3d41.41344937519914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2457f3ab34eb93%3A0xd5c5906f438cf486!2sPlastifa%20-%20Pl%C3%A1sticos%20T%C3%A9cnicos%2C%20Lda.!5e0!3m2!1spt-PT!2spt!4v1622027618688!5m2!1spt-PT!2spt" width="100%" height="350" frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            <li class="open"> Werk mit 25 Maschinen </ li> 
            <li class="open"> Abteilungen: </ li> 
            <li class="open marge"> Prozessoptimierung </ li> 
            <li class="open marge"> Ausbildung </ li> 
            <li class="open"> Lager </ li>
            <li class="open"> Wartung von Werkzeugen und Geräten </ li>
        </div>
        <div className="column">
           
        </div>
        <div className="column2">
            <h2>Werk 2</h2>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2992.345465145687!2d-8.459357184709578!3d41.410018879262196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd24f78df06db705%3A0x29cbd94b7b52b239!2sPLASTIFA%20--%20Unidade%202%20-Plant%202!5e0!3m2!1spt-PT!2spt!4v1622027763008!5m2!1spt-PT!2spt" width="100%" height="350" frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            <li class="open"> Werk mit 8 Maschinen </ li> 
            <li class="open"> Empfang </ li> 
            <li class="open"> Abteilungen: </ li> 
            <li class="open marge"> Qualität </ li> 
            <li class="open marge"> Verwaltung </ li> 
            <li class="open marge"> Logistik </ li> 
            <li class="open marge"> Finanzen </ li> 
            <li class="open marge"> Vertrieb </ li> 
            <li class="open marge"> Technik </ li> 
            <li class="open marge"> Industrialisierung </ li> 
            <li class="open marge"> Produktentwicklung </ li> 
            <li class="open marge"> Geschäftskontakt </ li> 
            <li class="open"> Lager </ li>
            <li class="open"> Werkzeugwartung </ li>
        </div>
      </div>
      </div>
    )
}

export default Contact;